module.exports = __webpack_public_path__ + "static/media/land-rover-go-drive.c045a61f.png";